import ArticlesPreviewSectionBottom, {
    ArticlesPreviewTop,
} from "@components/ArticlesPreviewMainPage/ArticlesPreview.component";
import FlippingBookNewNumber from "@components/NewMagazineFB/NewMagazine";
import styled from "styled-components";
import BlockSection from "../../components/BlockSection/Block.component";
import NewsletterContainer from "../../components/NewsletterComponent/Newsletter.component";
import coverMockupPNG from "./../../assets/img/cover2_mockup.png";

const BlocksWrapper = styled.main`
    display: grid;
    width: 100%;
    height: auto;
    grid-template-columns: minmax(1fr, 970px);

    /* @media screen and (max-width: 830px) {
        grid-template-columns: 1fr;
        padding: 0 40px;
        grid-auto-rows: auto;
    } */
`;

const HomePage = (props) => {
    return (
        <>
            <BlocksWrapper>
                <BlockSection
                    id="opis"
                    img={coverMockupPNG}
                    title=""
                    containImg
                    centerImg
                    smallIMG
                    inverted
                    invertedOnMobile
                >
                    <p>
                        <b>Poznaj Magazyn Zdrowe Dziecko</b>
                    </p>
                    <h4 className="uppercase">Magazyn dla rodziców</h4>
                    <p>
                        Profesjonalne wsparcie dla rodziców dzieci młodszych
                        oraz starszych. Oś magazynu stanowią kwestie zdrowotne u
                        dzieci, w tym praktyczne aspekty zdrowego odżywiania i
                        stylu życia oraz choroby i dolegliwości wieku
                        dziecięcego, jak i sposoby radzenia sobie z nimi.
                        Równolegle poruszamy także tematykę rozwoju
                        psychofizycznego dziecka oraz wspierania edukacji.
                    </p>
                </BlockSection>
            </BlocksWrapper>
            <FlippingBookNewNumber />

            <ArticlesPreviewTop />
            <ArticlesPreviewSectionBottom />
            <NewsletterContainer />
        </>
    );
};
export default HomePage;
